/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SysMaintenanceData model module.
 * @module model/SysMaintenanceData
 * @version 1.0
 */
class SysMaintenanceData {
    /**
     * Constructs a new <code>SysMaintenanceData</code>.
     * @alias module:model/SysMaintenanceData
     */
    constructor() { 
        
        SysMaintenanceData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SysMaintenanceData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SysMaintenanceData} obj Optional instance to populate.
     * @return {module:model/SysMaintenanceData} The populated <code>SysMaintenanceData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SysMaintenanceData();

            if (data.hasOwnProperty('maintenanceNo')) {
                obj['maintenanceNo'] = ApiClient.convertToType(data['maintenanceNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('isUrgent')) {
                obj['isUrgent'] = ApiClient.convertToType(data['isUrgent'], 'Boolean');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SysMaintenanceData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SysMaintenanceData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {Number} maintenanceNo
 */
SysMaintenanceData.prototype['maintenanceNo'] = undefined;

/**
 * @member {String} title
 */
SysMaintenanceData.prototype['title'] = undefined;

/**
 * @member {Boolean} isUrgent
 */
SysMaintenanceData.prototype['isUrgent'] = undefined;

/**
 * @member {Date} startedAt
 */
SysMaintenanceData.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
SysMaintenanceData.prototype['endedAt'] = undefined;






export default SysMaintenanceData;

